export default {
  title: 'Ugentlige resultater',
  messages_sent: 'Sendte beskeder',
  messages_delivered: 'Leverede beskeder',
  click_rate: 'Gennemsnitlig klikrate',
  awaiting: 'Afventer bekræftelse',
  legend: {
    sent: 'Sendt',
    clicked: 'Klikket',
    delivered: 'Leveret',
  },
  error_messages: {
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
};
